import { intlFormat } from 'date-fns';
import { Locale } from 'interfaces/language';

export function formatDateByUserLocale(date: Date, userLocale: Locale): string {
  const formattedDateByUserLocale = intlFormat(
    new Date(date),
    {},
    { locale: userLocale },
  );

  return formattedDateByUserLocale;
}
